<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row>
        <el-form-item
          :label="$l('form_label_attribute_type') || '属性类型'"
          prop="metadataType"
        >
          <el-input
            clearable
            v-model="formData.metadataType"
            :placeholder="
              $l('form_label_please_attribute_type') || '请输入属性类型'
            "
            :disabled="useless"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$l('form_label_attribute_name') || '属性名称'"
          prop="metadataName"
        >
          <el-input
            clearable
            v-model="formData.metadataName"
            :placeholder="
              $l('form_label_please_attribute_name') || '请输入属性名称'
            "
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$l('form_label_attribute_name_english') || '属性名称英文'"
          prop="metadataNameEn"
        >
          <el-input
            clearable
            v-model="formData.metadataNameEn"
            :placeholder="
              $l('form_label_please_attribute_name_english') ||
                '请输入属性名称英文'
            "
          ></el-input>
        </el-form-item>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('form_label_tree_option') || '是否树形选项'"
            prop="isTree"
          >
            <el-radio-group v-model="formData.isTree">
              <el-radio label="Y">{{ $l("from_radio_yes") || "是" }}</el-radio>
              <el-radio label="N">{{ $l("from_radio_no") || "否" }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('form_label_valid_status') || '有效状态'"
            prop="metadataStatus"
          >
            <el-radio-group :disabled="true" v-model="formData.metadataStatus">
              <el-radio label="Y">{{
                $l("from_radio_effective") || "有效"
              }}</el-radio>
              <el-radio label="N">{{
                $l("from_radio_invalid") || "无效"
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l("INDEX.tips_question_save") || "是否要保存更改" }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l("INDEX.btn_cancel") || "取消"
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l("INDEX.btn_no_save") || "不保存"
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l("INDEX.btn_save") || "保存"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from "@/libs/util.validate"
export default {
  props: {
    disabled: Boolean,
    useless: Boolean,
    code: String,
    metadataCode: String,
    metadataType: String,
  },
  components: {},
  data() {
    return {
      backDialogVisible: false,
      formData: {
        metadataStatus: "Y",
        isTree: "N",
      },
      rules: {
        metadataType: [
          {
            required: true,
            message:
              this.$l("form_label_please_attribute_type") || "请输入属性类型",
            trigger: "blur",
          },
        ],
        metadataName: [
          {
            required: true,
            message:
              this.$l("form_label_please_attribute_name") || "请输入属性名称",
            trigger: "blur",
          },
        ],
        metadataNameEn: [
          {
            required: true,
            message:
              this.$l("form_label_please_attribute_name_english") ||
              "请输入属性名称英文",
            trigger: "blur",
          },
        ],
        metadataStatus: [
          {
            required: true,
            message:
              this.$l("form_label_please_valid_status") || "请选择有效状态",
            trigger: "change",
          },
        ],
        isTree: [
          {
            required: true,
            message:
              this.$l("form_label_please_tree_option") || "请选择树形选项",
            trigger: "change",
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.code) return
      this.$api
        .materialmaterialMetadataDetailApi({
          metadataCode: this.code,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)
      let loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      this.$api
        .materialmaterialMetadataSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
          })
          this.$emit("close")
          this.$emit("reload")
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      if (this.useless) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit("close")
    },
  },
}
</script>
